import { UniformsUtils } from 'three';

import { materialEasyUniforms } from '@resn/gozer-three';

export const replaceMaterialSnippets = ({
    material,
    uniforms = {},
    vertex = null,
    fragment = null,
} = {}) => {
    material.uniforms = UniformsUtils.merge([material.uniforms, uniforms]);

    materialEasyUniforms(material, material.uniforms);

    material.onBeforeCompile = (shader) => {
        Object.assign(shader.uniforms, material.uniforms);
        // shader.uniforms = UniformsUtils.merge([shader.uniforms, material.uniforms]);

        if (vertex) replaceSnippets(shader, 'vertexShader', vertex);
        if (fragment) replaceSnippets(shader, 'fragmentShader', fragment);
    };
};

export const replaceSnippets = (shader, type = 'vertexShader', snippets) => {
    snippets.forEach(({ snippet, newSnippet, insert = 'after' } = {}) => {
        switch (insert) {
            case 'after':
                shader[type] = shader[type].replace(snippet, `${snippet}\n${newSnippet}`);
                break;
            case 'before':
                shader[type] = shader[type].replace(snippet, `${newSnippet}\n${snippet}`);
                break;
            case 'replace':
                shader[type] = shader[type].replace(snippet, newSnippet);
                break;
            default:
                break;
        }
    });
};
